import banner01 from "../img/Banners/software.jpg";
import banner02 from "../img/Banners/長照圖片.jpg";
import { successCaseIntro } from './SuccessCaseMeta';

const successCaseBanner = {
    solidBackground: true,
    backgroundDescriptions: [
        { text: successCaseIntro.title, style: { marginBottom: '30px' } },
        { text: successCaseIntro.subtitle, style: { marginBottom: '20px' } },
        { text: successCaseIntro.seoNote, style: {} },
    ],
};

const Banner = {
    "/productintro":{backgroundUrl:banner02,
        backgroundDescriptions:[{text:"AI 應用系統服務 — 智能客服、企業知識庫、文件辨識與電子零件查價。",style:{marginBottom:"30px"}},
        {text:`導入 LLM 與 RAG 技術，協助零售、電商、製造與採購團隊提升客服效率、知識檢索、文件自動化與 BOM 全球比價決策能力。`,style:{}}]},
    "/ai-inventory":{backgroundUrl:banner01,
        backgroundDescriptions:[{text:"智慧進銷存管理系統 — 訂單、採購、庫存與 AI 語意對話深度整合。",style:{marginBottom:"30px"}},
        {text:`免翻找報表，用自然語言對話即可掌控全廠數據，即時查詢、分析並圖表化呈現決策建議。`,style:{}}]},
    "/successcase": successCaseBanner,
    "/SuccessCase": successCaseBanner,
} 

export default Banner;

export const DefaultBanner = {
    backgroundUrl:banner01,
    backgroundDescriptions:[{text:"匯融科技 | 專業客製化軟體開發",style:{marginBottom: "30px"}},{text:"提供程式軟體開發人力需求",style:{}},
    {text:"解決客戶在資訊系統開發與維護不同階段的人力資源需求",style:{}},
    {text:`匯融擁有超過 15 年 委外軟體開發、教育訓練、資訊系統整合、委外、開發、維護等資訊服務經驗，
    客戶遍及製造業、電子業、科技業、一般公司，及政府部門等產業，
    能提供企業專業技術人才，強化核心競爭力`,style:{}}]
}